import { render, staticRenderFns } from "./BookMainTab.html?vue&type=template&id=507fd660&scoped=true&"
import script from "./BookMainTab.ts?vue&type=script&lang=ts&"
export * from "./BookMainTab.ts?vue&type=script&lang=ts&"
import style0 from "./BookMainTab.scss?vue&type=style&index=0&id=507fd660&scoped=true&lang=scss&"
import style1 from "./BookMainTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507fd660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
